/**
 * Generated bundle index. Do not edit.
 */

export * from './index';

export {InovaNavGraphqlApi as ɵa} from './services/nav-api.service';